module.exports = "/public/images/0bf86bf00faac0d0ef3706c2f9cfb2d6.svg";